/**
 * Patient Call — field-level effects.
 *
 * Migrated from: patient/patient-call.coffee
 *
 * Old validators → new effects:
 *   SetAssociatedMedication → SetAssociatedMedication
 *   MedicationShortName     → MedicationShortName
 *
 * Skipped:
 *   handle(dfd) init logic (allow_inactive_edit, set_default_value, set_previous) — form-load
 *   event_subform_edit_row — Backbone view event, not a validator
 */
import { buildApiUrl, fetchAPI } from "@neu/libui";
import type { FieldHandler } from "@neu/libui";

// ─── SetAssociatedMedication ────────────────────────────────────────────────
// Old: DSLFx.Validators.SetAssociatedMedication
// Trigger field: note_related_to (case selection)
// Looks up the patient_case by the selected case ID and sets associated_med
// to the case's medication_id.
export const SetAssociatedMedication: FieldHandler = (field, { form }) => {
	void (async () => {
		const caseId = field.value;

		form.setFieldState("associated_med", (s) => {
			s.value = "";
		});

		if (!caseId) return;

		try {
			const data = await fetchAPI(buildApiUrl(`/patient_case/${caseId}`));
			const row = Array.isArray(data) ? data[0] : data;
			if (row?.medication_id) {
				form.setFieldState("associated_med", (s) => {
					s.value = row.medication_id;
				});
			}
		} catch (err) {
			console.error("SetAssociatedMedication: API error", err);
		}
	})();
	return "";
};

// ─── MedicationShortName ────────────────────────────────────────────────────
// Old: DSLFx.Validators.MedicationShortName
// Trigger field: associated_med (medication selection)
// Looks up the inventory item and sets assoc_med_short_name to the brand name.
export const MedicationShortName: FieldHandler = (field, { form }) => {
	void (async () => {
		const medId = field.value;

		form.setFieldState("assoc_med_short_name", (s) => {
			s.value = "";
		});

		if (!medId) return;

		try {
			const data = await fetchAPI(buildApiUrl(`/inventory/${medId}`));
			const row = Array.isArray(data) ? data[0] : data;
			if (row?.brand_name_id_auto_name) {
				form.setFieldState("assoc_med_short_name", (s) => {
					s.value = row.brand_name_id_auto_name;
				});
			}
		} catch (err) {
			console.error("MedicationShortName: API error", err);
		}
	})();
	return "";
};
